import React from "react";

const ItemCardShimmer = () => {
  return (
    <div className=" md:p-10 sm:p-5 p-3 flex flex-col gap-10">
      <p className="xs:block hidden bg-lightGray  w-72 h-8"></p>

      <div className="flex flex-col sm:flex-row md:gap-5 gap-3 md:justify-center items-start ">
        {/***** Images Container Shimmer  *****/}

        <div className="flex md:flex-row flex-col-reverse md:w-1/2 w-full md:gap-10 gap-5 items-center justify-center">
          {/*******  Small Images Shimmer   *****/}

          <div className="flex md:flex-col flex-row sm:items-start items-center justify-center w-full md:h-96 gap-3">
            <p className="md:w-20 sm:w-16 w-12 h-12 sm:h-16 md:h-20 bg-lightGray"></p>
            <p className="md:w-20 sm:w-16 w-12 h-12 sm:h-16 md:h-20 bg-lightGray"></p>
            <p className="md:w-20 sm:w-16 w-12 h-12 sm:h-16 md:h-20 bg-lightGray"></p>
          </div>
          {/*******    Main Image Shimmer   *****/}
          <div className="md:w-[24rem] w-60 h-72 md:h-[55rem] bg-lightGray">
            <p className=" w-full h-full"></p>
          </div>
        </div>
        <div className="flex md:w-1/2 flex-col xl:gap-5 md:gap-3 gap-1">
          <p className="bg-lightGray w-96 h-8"></p>
          <p className="bg-lightGray w-44 h-6"></p>
          <p className="bg-lightGray w-56 h-6"></p>
          <p className="bg-lightGray w-56 h-6"></p>
          <p className="bg-lightGray w-56 h-6"></p>
        </div>
        <div></div>
        <div></div>
      </div>
    </div>
  );
};

export default ItemCardShimmer;
